import {useEffect, useState} from "preact/compat";

// Special paths list
const PATHS = [
    "/entre",
    "/criar-conta",
    "/finalizar-cadastro",
    "/esqueci-a-senha",
    "/mudar-senha",
    "/checkout",
    "/nad"
]

/**
 *  Simple utility function to validate if something should behave differently
 *  if the user is located at one of the paths listed in the list located at the top of this file.
 *
 *  Data can be validated through the `isSpecialPath` flag returned from the object within the function
 *
 *  @returns {Object}
 * */
const useValidatePath = () => {
    // Stores the current path location.
    // It is being set at the app.js file on the page load.
    const [pathLocation, setPathLocation] = useState("");
    // Flag to validate if the current path is one of the special ones
    const [isSpecialPath, setIsSpecialPath] = useState(null);

    // Validates the page path on the page load
    useEffect(() => {
        // This used to be the initial implementation of this validation.
        // It'll be kept here just in case we need to roll back to it sometime.
        // setIsSpecialPath(
        //     PATHS.includes(pathLocation.split("?")[0])
        // );

        // Prevents component flicking at non-special-path pages
        if (!pathLocation) {
            return;
        }

        setIsSpecialPath(() => {
            let isIncluded = false;

            // This method was needed because if there were anything else other than path itself on the URL,
            // then the component wouldn't load as expected.
            PATHS.forEach(path => {
                /**
                 * We can't perform a shorthand attribution here (e.g.: isIncluded = pathLocation.split("?")[0].includes(path))
                 * because the value would be reset everytime the loop iterates through an item,
                 * and we don't want so as the current user path may actually be a special path while the last item of the array
                 * isn't. In a case like that, it would be set to false, even though it wasn't meant to be.
                 * So for now we shall keep it like this.
                 * */
                if (pathLocation.split("?")[0].includes(path)) {
                    isIncluded = true;
                }
            })

            return isIncluded;
        });
    }, [pathLocation]);

    return {
        pathLocation,
        setPathLocation,
        isSpecialPath
    }
}

export default useValidatePath;
